/* eslint-disable camelcase */

/* eslint-disable max-statements */
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Tag } from 'primereact/tag';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import DisputeNotificationIcon from '../../../assets/DisputeNotification.png';
import { CertifyApprovalProcess } from '../../../components/certifyApprovalProcess/CertifyApprovalProcess';
import MessageInfo from '../../../components/messageInfo/MessageInfo';
import { EDSDASHBOARD } from '../../../constants';
import {
    useGetScorecardStatusQuery,
    useGetPrimaryApprovalWindowQuery,
    useGetScorecardApprovePCTSearchQuery,
    useUpdateApprovalWindowOverrideMutation,
    useUpdateInsertScorecardApprovalWindowMutation,
} from '../../../pages/compensation/compensationSlice';
import { selectCurrentEmpid, selectCurrentUser } from '../../../pages/login/authSlice';
import { datetimeToDate, getNextDate, getPreviuosDate } from '../../../utils/dateFormat';
import { ConstApprovalWindowStatus, monthNames } from '../../../utils/typeConstants';
import { ScoreCardPropTypes } from '../types';
import './PrimaryApproval.scss';
import DescriptionBox from '../../../components/descriptionBox/DescriptionBox';

enum Percentage {
    assosiate = 'ASSOC_APPROVE_PCT',
    teamLead = 'TL_APPROVE_PCT',
}
const PrimaryApproval = ({
    inputYear,
    inputMonth,
    inputScorecardVersion,
    inputReadonly,
    isApprovalHalted,
    via,
}: ScoreCardPropTypes) => {
    const loggedEmpUserName = useSelector(selectCurrentUser);
    const [updateInsertScorecardApprovalWindow] = useUpdateInsertScorecardApprovalWindowMutation();
    const [updateApprovalWindowOverride] = useUpdateApprovalWindowOverrideMutation();
    const overrideByEmpId = useSelector(selectCurrentEmpid);
    const [associateStartDate, setAssociateStartDate] = useState<any>(null);
    const [associateEndDate, setAssociateEndDate] = useState<any>(null);
    const [tLStartDate, setTLStartDate] = useState<any>(null);
    const [tLEndDate, setTLEndDate] = useState<any>(null);
    const [mgrStartDate, setMgrStartDate] = useState<any>(null);
    const [mgrEndDate, setMgrEndDate] = useState<any>(null);
    const [compStartDate, setCompStartDate] = useState<any>(null);
    const [compEndDate, setCompEndDate] = useState<any>(null);
    const [payoutTransmitDate, setPayoutTransmitDate] = useState<any>(null);
    const [isActiveDisabled, setIsActiveDisabled] = useState<boolean>(true);
    const [disableCompStartDate, setDisableCompStartDate] = useState<boolean>(false);
    const [disableCompEndDate, setDisableCompEndDate] = useState<boolean>(false);
    const [disableMgrEndDate, setDisableMgrEndDate] = useState<boolean>(false);
    const [disableMgrStartDate, setDisableMgrStartDate] = useState<boolean>(false);
    const [disableTransmitStartDate, setDisableTransmitStartDate] = useState<boolean>(false);
    const [disableTLStartDate, setDisableTLStartDate] = useState<boolean>(false);
    const [disableAssociateStartDate, setDisableAssociateStartDate] = useState<boolean>(false);
    const [disableAssociateEndDate, setDisableAssociateEndDate] = useState<boolean>(false);
    const [disableTLEndDate, setDisableTLEndDate] = useState<boolean>(false);
    const [approvalWindowStatusName, setApprovalWindowStatusName] = useState<string>('');
    const [approvalWindowConfigLevelId, setApprovalWindowConfigLevelId] = useState(0);
    const [approvalWindowStatusPaused, setApprovalWindowStatusPaused] = useState<boolean>(false);
    const [disablePrimaryApprovalWindows, setDisablePrimaryApprovalWindows] = useState<boolean>(false);
    const [approvalWindowStatusId, setApprovalWindowStatusId] = useState<number>(0);
    const [isMsgboxModal, setIsMsgboxModal] = useState<boolean>(false);
    const [continueBtnDisable, setContinueBtnDisable] = useState<boolean>(true);
    const [forceWindowBtnDisable, setForceWindowBtnDisable] = useState<boolean>(false);
    const [reasonText, setreasonText] = useState<string>('');
    const [scorecardApprovalWindowId, setScorecardApprovalWindowId] = useState<number>(0);
    const [selectedScApprovePCT, setSelectedScApprovePCT] = useState<any>({});
    const [disputeStatus, setDisputeStatus] = useState<boolean>(false);

    const openDateColClassName = (via === 'EdsDashboard' || via === 'ManagerDashboard') ? 'col-md-5' : 'col-md-2';
    const closeDateColClassName = (via === 'EdsDashboard' || via === 'ManagerDashboard') ? 'col-md-5' : 'col-md-2 offset-md-1';
    const buttonRowColClassName = (via === 'EdsDashboard' || via === 'ManagerDashboard') ? 'col-md-10' : 'col-md-5';

    const today = new Date();
    const month = today.getMonth();
    const year = today.getFullYear();
    const prevMonth = month === 0 ? 11 : month - 1;
    const prevYear = prevMonth === 11 ? year - 1 : year;
    const nextMonth = month === 11 ? 0 : month + 1;
    const nextYear = nextMonth === 0 ? year + 1 : year;

    const minDate = new Date();

    minDate.setMonth(prevMonth);
    minDate.setFullYear(prevYear);

    const maxDate = new Date();

    maxDate.setMonth(nextMonth);
    maxDate.setFullYear(nextYear);

    const { data: primaryApprovalWindowData } = useGetPrimaryApprovalWindowQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
            approvalWindowConfigLevelId: 3,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );
    const { data: scorecardApprovePCT } = useGetScorecardApprovePCTSearchQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputYear || !inputMonth || !inputScorecardVersion }
    );
    const { data: scorecardStatusData, isFetching: isScorecardStatusFetching } = useGetScorecardStatusQuery(
        {
            year: inputYear,
            month: inputMonth,
            scorecardVersionId: inputScorecardVersion,
        },
        { skip: !inputScorecardVersion || !inputMonth || !inputScorecardVersion || !disputeStatus }
    );

    const UpdateInsertScorecardApprovalWindow = (reviewStatus: any) => {
        updateInsertScorecardApprovalWindow(reviewStatus)
            .unwrap()
            .then(() => {
                toast.success('Scorecard approval window updated successfully');
            })
            .then((error: any) => {
                if (error) {
                    toast.error('Scorecard approval window update failed');
                }
            });
    };

    useEffect(() => {
        if (
            associateStartDate === null ||
            associateEndDate === null ||
            tLStartDate === null ||
            tLEndDate === null ||
            mgrStartDate === null ||
            mgrEndDate === null ||
            compStartDate === null ||
            compEndDate === null ||
            payoutTransmitDate === null ||
            inputScorecardVersion === null
        ) {
            setIsActiveDisabled(true);
            setForceWindowBtnDisable(true);
        } else {
            setIsActiveDisabled(false);
            setForceWindowBtnDisable(false);
        }
    }, [
        inputYear,
        inputMonth,
        inputScorecardVersion,
        associateStartDate,
        associateEndDate,
        tLStartDate,
        tLEndDate,
        mgrStartDate,
        mgrEndDate,
        compStartDate,
        compEndDate,
        payoutTransmitDate,
    ]);
    useEffect(() => {
        const windowData = primaryApprovalWindowData?.data[0];

        const disableDatesBasedOnStatus = () => {
            if (windowData) {
                const approvalWindowStatusId = windowData.approval_window_status_id;

                if (approvalWindowStatusId === null) {
                    clearDates();
                } else if (approvalWindowStatusId === ConstApprovalWindowStatus.ASSOCIATE_WINDOW) {
                    // Associate Window
                    setDisableAssociateStartDate(true);
                } else if (approvalWindowStatusId === ConstApprovalWindowStatus.TEAM_LEAD_WINDOW) {
                    // Team Lead Window
                    setDisableAssociateStartDate(true);

                    setDisableAssociateEndDate(true);
                    setDisableTLStartDate(true);
                } else if (approvalWindowStatusId === ConstApprovalWindowStatus.MANAGER_WINDOW) {
                    // Manager Window
                    setDisableAssociateStartDate(true);
                    setDisableAssociateEndDate(true);
                    setDisableTLStartDate(true);

                    setDisableTLEndDate(true);
                    setDisableMgrStartDate(true);
                } else if (approvalWindowStatusId === ConstApprovalWindowStatus.COMPENSATION_TEAM_WINDOW) {
                    // Compensation Team Window
                    setDisableAssociateStartDate(true);
                    setDisableAssociateEndDate(true);
                    setDisableTLStartDate(true);
                    setDisableTLEndDate(true);
                    setDisableMgrStartDate(true);

                    setDisableMgrEndDate(true);
                    setDisableCompStartDate(true);
                }
            }
        };

        clearDates();
        manipulateAllDates(false);
        setApprovalWindowStatusName('');
        setApprovalWindowStatusPaused(false);
        setDisablePrimaryApprovalWindows(false);

        if (windowData) {
            const {
                approval_window_status_name,
                approvals_paused,
                associate_start_date,
                associate_end_date,
                team_lead_start_date,
                team_lead_end_date,
                manager_start_date,
                manager_end_date,
                comp_team_start_date,
                comp_team_end_date,
                payout_transmit_date,
                approval_window_status_id,
                scorecard_approval_window_id,
                approval_window_config_level_id,
            } = windowData;

            setApprovalWindowStatusName(approval_window_status_name);
            setApprovalWindowStatusPaused(approvals_paused);
            setApprovalWindowConfigLevelId(approval_window_config_level_id);

            setDisablePrimaryApprovalWindows(
                approval_window_status_id === ConstApprovalWindowStatus.CLOSED ||
                approval_window_status_id === ConstApprovalWindowStatus.READY_FOR_EXTRACT
            );

            setAssociateStartDate(associate_start_date ? new Date(associate_start_date) : null);
            setAssociateEndDate(associate_end_date ? new Date(associate_end_date) : null);
            setTLStartDate(team_lead_start_date ? new Date(team_lead_start_date) : null);
            setTLEndDate(team_lead_end_date ? new Date(team_lead_end_date) : null);
            setMgrStartDate(manager_start_date ? new Date(manager_start_date) : null);
            setMgrEndDate(manager_end_date ? new Date(manager_end_date) : null);
            setCompStartDate(comp_team_start_date ? new Date(comp_team_start_date) : null);
            setCompEndDate(comp_team_end_date ? new Date(comp_team_end_date) : null);
            setPayoutTransmitDate(payout_transmit_date ? new Date(payout_transmit_date) : null);
            setApprovalWindowStatusId(approval_window_status_id);
            setScorecardApprovalWindowId(scorecard_approval_window_id);

            disableDatesBasedOnStatus();
        }

        if (inputReadonly === true || disablePrimaryApprovalWindows === true) {
            manipulateAllDates(true);
        }
    }, [inputYear, inputMonth, inputScorecardVersion, inputReadonly, primaryApprovalWindowData]);

    useEffect(() => {
        if (!isScorecardStatusFetching && scorecardStatusData?.data?.length > 0) {
            const metric_disputes = scorecardStatusData?.data[0].open_metric_disputes;
            const scorecard_disputes = scorecardStatusData?.data[0].open_scorecard_disputes;
            if (metric_disputes > 0 || scorecard_disputes > 0) {
                let statusMsg = 'There are';
                if (metric_disputes > 0) {
                    statusMsg += ` ${metric_disputes} Agent Disputes`;
                }
                if (scorecard_disputes > 0) {
                    statusMsg += `${metric_disputes > 0 ? ' and ' : ''
                        } ${scorecard_disputes} Scorecard Disputes`;
                }
                toast.error(
                    `${statusMsg} Open.These disputes must be resolved before advancing the approval window.This prevents calculations using erroneous data.`
                );
            } else {
                getPCTValue();
                setIsMsgboxModal(true);
            }
        }
        setDisputeStatus(false);
    }, [scorecardStatusData]);
    const manipulateAllDates = (disable: boolean) => {
        setDisableAssociateEndDate(disable);
        setDisableAssociateStartDate(disable);
        setDisableTLStartDate(disable);
        setDisableTLEndDate(disable);
        setDisableMgrStartDate(disable);
        setDisableMgrEndDate(disable);
        setDisableCompStartDate(disable);
        setDisableCompEndDate(disable);
        setDisableTransmitStartDate(disable);
    };

    const clearDates = () => {
        setAssociateStartDate(null);
        setAssociateEndDate(null);
        setTLStartDate(null);
        setTLEndDate(null);
        setMgrStartDate(null);
        setMgrEndDate(null);
        setCompStartDate(null);
        setCompEndDate(null);
        setPayoutTransmitDate(null);
    };
    const changeAssociateEndDate = (e: any) => {
        setAssociateEndDate(e.value);
        setTLStartDate(getNextDate(e.value));
    };
    const changeTLStartDate = (e: any) => {
        setTLStartDate(e.value);
        setAssociateEndDate(getPreviuosDate(e.value));
    };

    const changeTLEndDate = (e: any) => {
        setTLEndDate(e.value);
        setMgrStartDate(getNextDate(e.value));
    };
    const changeMgrStartDate = (e: any) => {
        setMgrStartDate(e.value);
        setTLEndDate(getPreviuosDate(e.value));
    };

    const changeMgrEndDate = (e: any) => {
        setMgrEndDate(e.value);
        setCompStartDate(getNextDate(e.value));
    };
    const changeCompStartDate = (e: any) => {
        setCompStartDate(e.value);
        setMgrEndDate(getPreviuosDate(e.value));
    };
    const changeCompEndDate = (e: any) => {
        setCompEndDate(e.value);
        setPayoutTransmitDate(getNextDate(e.value));
    };
    const changePayoutTransmitDate = (e: any) => {
        setPayoutTransmitDate(e.value);
        setCompEndDate(getPreviuosDate(e.value));
    };
    const accept = () => {
        onActivateClick();
    };

    const reject = () => {
        toast.error('You have rejected');
    };
    const confirmActivate = () => {
        confirmDialog({
            message: 'These approval dates will apply only to the selected scorecard.',
            header: 'Status Update',
            icon: 'pi pi-info-circle',
            accept,
            reject,
        });
    };
    const onActivateClick = () => {
        setIsActiveDisabled(true);
        if (checkScorecardApprovalWindowValidation() && checkApprovalDates()) {
            const payload = {
                scorecard_version_id: inputScorecardVersion,
                year: inputYear,
                month: inputMonth,
                associate_start_date: datetimeToDate(associateStartDate),
                team_lead_start_date: datetimeToDate(tLStartDate),
                manager_start_date: datetimeToDate(mgrStartDate),
                comp_team_start_date: datetimeToDate(compStartDate),
                payout_transmit_date: datetimeToDate(payoutTransmitDate),
                approval_window_config_level_id: 3,
            };
            UpdateInsertScorecardApprovalWindow(payload);
        }
        setIsActiveDisabled(false);
    };

    const getPCTValue = () => {
        let selectedPCT: any = [];
        if (approvalWindowStatusId === ConstApprovalWindowStatus.ASSOCIATE_WINDOW)
            selectedPCT = scorecardApprovePCT?.data?.filter(
                (data: any) => data.column_name === Percentage.assosiate
            );
        else if (approvalWindowStatusId === ConstApprovalWindowStatus.TEAM_LEAD_WINDOW)
            selectedPCT = scorecardApprovePCT?.data?.filter(
                (data: any) => data.column_name === Percentage.teamLead
            );

        setSelectedScApprovePCT(selectedPCT?.length > 0 ? selectedPCT[0] : {});
    };

    const checkScorecardApprovalWindowValidation = (): boolean => {
        if (
            inputScorecardVersion === null ||
            inputScorecardVersion === undefined ||
            inputScorecardVersion <= 0 ||
            inputYear === null ||
            inputYear === undefined ||
            inputYear <= 0 ||
            inputMonth === null ||
            inputMonth === undefined ||
            inputMonth <= 0
        ) {
            toast.error('Please select scorecard version, year and month');
            return false;
        }
        return true;
    };
    const checkApprovalDates = (): boolean => {
        try {
            if (associateStartDate.getTime() > associateEndDate.getTime()) {
                toast.error('Please check the Associate approval dates range');
                return false;
            }
            if (tLStartDate.getTime() > tLEndDate.getTime()) {
                toast.error('Please check the Team Lead approval dates range');
                return false;
            }

            if (mgrStartDate.getTime() > mgrEndDate.getTime()) {
                toast.error('Please check the Manager approval dates range');
                return false;
            }
            if (compStartDate.getTime() > compEndDate.getTime()) {
                toast.error('Please check the Compensation approval dates range');
                return false;
            }
            if (mgrEndDate.getTime() > payoutTransmitDate.getTime()) {
                toast.error('Please check the Transmit approval dates range');
                return false;
            }

            return true;
        } catch (error) {
            toast.error('Please check the approval dates range');
            return false;
        }
    };

    const UpdateApprovalWindowOverride = (approvalWindowAuditOverride: any) => {
        updateApprovalWindowOverride(approvalWindowAuditOverride)
            .unwrap()
            .then((data: any) => {
                if (data?.data) return toast.success('Update Approval Window Override Successfully');
                return toast.error('Update Approval Window Override Failed');
            });
    };

    const onContinueClick = () => {
        setContinueBtnDisable(true);
        const payload = {
            scorecardVersionId: inputScorecardVersion,
            year: inputYear,
            month: inputMonth,
            scorecardApprovalWindowId,
            approvalWindowStatusId,
            currentApprovalPercentage: selectedScApprovePCT?.column_value,
            overrideBy: overrideByEmpId,
            overrideReason: reasonText,
        };
        //calling api here
        UpdateApprovalWindowOverride(payload);
        setreasonText('');
        setContinueBtnDisable(false);
        dialogFuncMap.mesgBoxModal(false);
    };

    const dialogFuncMap = {
        mesgBoxModal: setIsMsgboxModal,
    };

    const onMsgBoxModalHide = () => {
        dialogFuncMap.mesgBoxModal(false);
    };

    const footerTemplate = (
        <div className="row">
            <div className="col-md-4">&nbsp;</div>
            <div className="col-md-4">
                <Button
                    className="btn btn-secondary"
                    onClick={onMsgBoxModalHide}
                    label="Cancel"
                />
            </div>
            <div className="col-md-4">
                <Button
                    className="btn btn-primary"
                    disabled={continueBtnDisable}
                    onClick={onContinueClick}
                    label="Continue"
                />
            </div>
        </div>
    );

    const handleReasonTextChange = (value: string) => {
        setContinueBtnDisable(value?.length <= 0);
        setreasonText(value);
    };

    const pathArray = window.location.pathname.split('/');
    const pageName = '/' + pathArray[pathArray.length - 1];

    if (primaryApprovalWindowData?.data?.length > 0) {
        return (
            <div className="card shadow border-0 h-100 borderRadius10 PrimaryApproval">
                <ConfirmDialog />
                <div className={`card-body `}>
                    {pageName === EDSDASHBOARD && (
                        <CertifyApprovalProcess
                            inputYear={inputYear}
                            inputMonth={inputMonth}
                            inputScorecardVersion={inputScorecardVersion}
                        />
                    )}
                    <hr />
                    <h6 className="card-title">
                        <b>Pay Period</b> :
                        <i style={{ fontWeight: 'normal' }}>
                            {' '}
                            {monthNames[inputMonth ?? 0]} {inputYear}{' '}
                        </i>
                    </h6>
                    Scorecard Status{' '}
                    {approvalWindowStatusPaused ? (
                        <Tag
                            className="mr-2"
                            icon="pi pi-times"
                            severity="danger"
                            value={approvalWindowStatusName + ' (Stalled)'}
                        />
                    ) : (
                        <Tag
                            className="mr-2"
                            icon="pi pi-info-circle"
                            severity="info"
                            value={approvalWindowStatusName}
                        />
                    )}
                    {approvalWindowConfigLevelId === 1 && (
                        <Tag className="float-end" severity="info" value="Inherited from Global" rounded />
                    )}
                    {approvalWindowConfigLevelId === 2 && (
                        <Tag className="float-end" severity="info" value="Inherited from Client" rounded />
                    )}
                    {approvalWindowConfigLevelId === 3 && (
                        <Tag className="float-end" severity="info" value="Scorecard Specific" rounded />
                    )}
                    <hr className="mt-3" />
                    <div className="row mt-3">
                        <div className="col-md-2 pe-0">&nbsp;</div>
                        <div className={openDateColClassName}>Open Date</div>
                        <div className={closeDateColClassName}>Close Date</div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-md-2 pe-0 pt-2">Associate</div>
                        <div className={openDateColClassName}>
                            <Calendar
                                id="icon"
                                value={associateStartDate}
                                dateFormat="dd-M-yy"
                                onChange={(e: any) => setAssociateStartDate(e.value)}
                                showIcon
                                disabled={disableAssociateStartDate}
                                className={`custom-calendar ${associateStartDate === null ? 'p-invalid' : ''
                                    }`}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                        <div className={closeDateColClassName}>
                            <Calendar
                                id="icon"
                                value={associateEndDate}
                                dateFormat="dd-M-yy"
                                disabled={disableAssociateEndDate}
                                onChange={changeAssociateEndDate}
                                showIcon
                                className={`custom-calendar ${associateEndDate === null ? 'p-invalid' : ''
                                    }`}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 pe-0 pt-2">Team Lead</div>
                        <div className={openDateColClassName}>
                            <Calendar
                                id="icon"
                                value={tLStartDate}
                                dateFormat="dd-M-yy"
                                disabled={disableTLStartDate}
                                onChange={changeTLStartDate}
                                showIcon
                                className={`custom-calendar ${tLStartDate === null ? 'p-invalid' : ''}`}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                        <div className={closeDateColClassName}>
                            <Calendar
                                id="icon"
                                value={tLEndDate}
                                dateFormat="dd-M-yy"
                                onChange={changeTLEndDate}
                                disabled={disableTLEndDate}
                                showIcon
                                className={`custom-calendar ${tLEndDate === null ? 'p-invalid' : ''}`}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 pe-0 pt-2">Manager</div>
                        <div className={openDateColClassName}>
                            <Calendar
                                disabled={disableMgrStartDate}
                                id="icon"
                                value={mgrStartDate}
                                dateFormat="dd-M-yy"
                                onChange={changeMgrStartDate}
                                showIcon
                                className={`custom-calendar ${mgrStartDate === null ? 'p-invalid' : ''}`}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                        <div className={closeDateColClassName}>
                            <Calendar
                                disabled={disableMgrEndDate}
                                id="icon"
                                value={mgrEndDate}
                                dateFormat="dd-M-yy"
                                onChange={changeMgrEndDate}
                                showIcon
                                className={`custom-calendar ${mgrEndDate === null ? 'p-invalid' : ''}`}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 pe-0 pt-2">Comp</div>
                        <div className={openDateColClassName}>
                            <Calendar
                                disabled={disableCompStartDate}
                                id="icon"
                                value={compStartDate}
                                dateFormat="dd-M-yy"
                                onChange={changeCompStartDate}
                                showIcon
                                className={`custom-calendar ${compStartDate === null ? 'p-invalid' : ''}`}
                                minDate={minDate}
                                maxDate={maxDate}
                            />
                        </div>
                        <div className={closeDateColClassName}>
                            <Calendar
                                id="icon"
                                value={compEndDate}
                                dateFormat="dd-M-yy"
                                onChange={changeCompEndDate}
                                showIcon
                                className={`custom-calendar ${compEndDate === null ? 'p-invalid' : ''}`}
                                minDate={minDate}
                                maxDate={maxDate}
                                disabled={disableCompEndDate}
                            />
                        </div>
                    </div>
                    <div className="row mt-3">
                        <div className="col-md-2 pe-0 pt-2">Transmit</div>
                        <div className={openDateColClassName}>
                            <Calendar
                                id="icon"
                                value={payoutTransmitDate}
                                dateFormat="dd-M-yy"
                                onChange={changePayoutTransmitDate}
                                showIcon
                                className={`custom-calendar ${payoutTransmitDate === null ? 'p-invalid' : ''}`}
                                minDate={minDate}
                                maxDate={maxDate}
                                disabled={disableTransmitStartDate}
                            />
                        </div>
                    </div>
                    {!(inputReadonly || disablePrimaryApprovalWindows) && (
                        <div className="row mt-3">
                            <div className="col-md-2 pe-0">&nbsp;</div>
                            <div className={`${buttonRowColClassName} d-flex justify-content-end flex-wrap gap-2`}>
                                <Button
                                    className="btn-secondary"
                                    style={{ minWidth: '140px' }}
                                    onClick={clearDates}
                                    label="Cancel"
                                />
                                <Button
                                    disabled={isActiveDisabled}
                                    className="btn-primary"
                                    style={{ minWidth: '150px' }}
                                    onClick={confirmActivate}
                                    label={isApprovalHalted ? 'Restart' : 'Activate'}
                                />
                                {((approvalWindowStatusPaused &&
                                    (approvalWindowStatusId ===
                                        ConstApprovalWindowStatus.ASSOCIATE_WINDOW)) ||
                                    approvalWindowStatusId ===
                                    ConstApprovalWindowStatus.TEAM_LEAD_WINDOW) && (
                                        <Button
                                            className="btn-primary w-auto"
                                            style={{ minWidth: '150px' }}
                                            disabled={forceWindowBtnDisable}
                                            onClick={() => {
                                                setDisputeStatus(true);
                                            }}
                                            label="Force Window Advance"
                                        />
                                    )}
                            </div>
                        </div>
                    )}
                </div>
                <Dialog
                    visible={isMsgboxModal}
                    className="reason-dialog"
                    onHide={() => onMsgBoxModalHide()}
                    footer={footerTemplate}
                    style={{ width: '35%' }}
                >
                    <div className="dialog-body">
                        <div className="dialog-title">
                            <img
                                className="notification-icon"
                                src={DisputeNotificationIcon}
                                alt={DisputeNotificationIcon}
                            />
                            <p>
                                You are advancing the window with {selectedScApprovePCT?.column_value} % of
                                approvals. Please, provide a reason:
                            </p>
                        </div>
                        <DescriptionBox
                            createdByLabel="Author"
                            createdByValue={loggedEmpUserName}
                            responseDescription={reasonText}
                            value={reasonText}
                            limit={4000}
                            onChange={handleReasonTextChange}
                            placeholder="Please provide reason"
                        />
                    </div>
                </Dialog>
            </div>
        );
    }

    return (
        <div className="col-12">
            <MessageInfo
                title="No results found."
                message="Try adjusting the month or scorecard filter above."
                rowHeight="308px"
            />
        </div>
    );
};

export default PrimaryApproval;
